module.exports = __webpack_public_path__ + "04_long_black.a565b3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_long_black.png
// module id = RzQF
// module chunks = 0